var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('pricesTableComponent',{attrs:{"lang":_vm.lang,"title":'pages.prices',"general":"general"}}),_c('faqSections',{attrs:{"lang":_vm.lang,"title":'pages.prices.faq',"general":"general"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }